// Modules
import './bootstrap';
import Vuelidate from 'vuelidate';
import VueScrollTo from 'vue-scrollto';
import VueClipboard from 'vue-clipboard2';
import VueYouTubeEmbed from 'vue-youtube-embed';
import store from 'commons/js/vuex/store';
import disconnectionWatcher from 'dash/js/services/Disconnect';
import {orderGenerationWatcher} from 'commons/js/OrderGeneration';
import {orderCancellationWatcher} from 'commons/js/OrderCancellation';
import {sanitizeUrl} from "@braintree/sanitize-url";
import {detect} from 'commons/js/utils/platform-detection';
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip';

// Components
import MECart from '@homeComponents/Cart.vue';
import MECheckoutChargeback from '@homeComponents/CheckoutChargeback.vue';
import MECheckoutStatus from '@homeComponents/CheckoutStatus.vue';
import MEContractsAndPolices from '@homeComponents/ContractsAndPolices.vue';
import MECookiePolicy from '@homeComponents/CookiePolicy.vue';
import MELoading from 'commons/js/components/assets/Loading.vue';
import MELogin from '@homeComponents/Login.vue';
import MEMap from 'commons/js/components/map/Map.vue';
import MENavbar from 'commons/js/components/Navbar.vue';
import MENavbarLoggedOut from '@homeComponents/NavbarLoggedOut.vue';
import MEPasswordRecovery from '@homeComponents/PasswordRecovery.vue';
import MEPrinterBox from '@homeComponents/PrinterBox.vue';
import MEPrinterPreview from '@homeComponents/PrinterPreview.vue';
import MERegulation from '@homeComponents/Regulation.vue';
import MEShipmentContentBox from '@homeComponents/ShipmentContentBox.vue';
import MESidebar from '@dashComponents/assets/Sidebar.vue';
import MESidebarLoggedOut from '@dashComponents/assets/SidebarLoggedOut.vue';
import MEStackedToast from 'commons/js/components/atoms/StackedToast.vue';
import MENewSignup from '@homeComponents/NewSignup.vue';
import MESignupBanner from '@homeComponents/new-signup/SignupBanner.vue';

/* --------------------------------------------
 PLATFORM DETECT
 --------------------------------------------- */
let {
  ieDetect,
  mobileDetect
} = detect();

Vue.config.ignoredElements = [/^ion-/u];

Vue.prototype.$sanitizeUrl = sanitizeUrl;

Vue.use(VueYouTubeEmbed);

Vue.use(VueClipboard);

Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: -80,
  cancelable: true,
  onDone: false,
  onCancel: false
});

Vue.use(Vuelidate);

// ----------------------------------------------------------------------------------
// Tooltip configs
VTooltip.options.defaultClass = 'vue-v-tooltip-theme';
VTooltip.options.defaultTemplate = '<div class="v-tooltip" role="tooltip"><div class="v-tooltip-arrow"></div><div class="v-tooltip-inner"></div></div>';
VTooltip.options.defaultArrowSelector = '.v-tooltip-arrow, .v-tooltip__arrow';
VTooltip.options.defaultInnerSelector = '.v-tooltip-inner, .v-tooltip__inner';
VTooltip.options.defaultLoadingClass = 'v-tooltip-loading';
VTooltip.options.defaultTrigger = 'hover focus click';
VTooltip.options.defaultHideOnTargetClick = false;
VTooltip.options.autoHide = false;
VTooltip.options.defaultDelay = {show: 100, hide: 200};

VTooltip.options.popover.defaultClass = 'vue-popover-theme';
VTooltip.options.popover.defaultBaseClass = 'v-tooltip popover';
VTooltip.options.popover.defaultWrapperClass = 'v-tooltip-wrapper';
VTooltip.options.popover.defaultInnerClass = 'v-tooltip-inner popover-inner';
VTooltip.options.popover.defaultArrowClass = 'v-tooltip-arrow popover-arrow';

Vue.use(VTooltip);
Vue.directive('close-popover', VClosePopover)
Vue.component('v-popover', VPopover)

Vue.component('me-cart', MECart);
Vue.component('me-checkout-chargeback', MECheckoutChargeback);
Vue.component('me-checkout-status', MECheckoutStatus);
Vue.component('me-contracts-polices', MEContractsAndPolices);
Vue.component('me-cookie-policy', MECookiePolicy);
Vue.component('me-loading', MELoading);
Vue.component('me-logged-menu', MENavbar);
Vue.component('me-login', MELogin);
Vue.component('me-map', MEMap);
Vue.component('me-menu', MENavbarLoggedOut);
Vue.component('me-painel-menu', MESidebar);
Vue.component('me-painel-menu-logout', MESidebarLoggedOut);
Vue.component('me-password-recovery', MEPasswordRecovery);
Vue.component('me-printer-box', MEPrinterBox);
Vue.component('me-printer-preview', MEPrinterPreview);
Vue.component('me-regulation', MERegulation);
Vue.component('me-shipment-content-box', MEShipmentContentBox);
Vue.component('me-stacked-toast', MEStackedToast);
Vue.component('new-me-signup', MENewSignup);
Vue.component('signup-banner', MESignupBanner);

const app = new Vue({
  el: '#app',
  store
});

$(document).ready(function () {
  disconnectionWatcher(app);
  orderGenerationWatcher(app);
  orderCancellationWatcher(app);
  svg4everybody();
});

let cache_expires = MEConfig.get('cache.expires');

if (cache_expires) {
  try {
    clearStorage(cache_expires);
  } catch (e) {}
}

function clearStorage(date) {
  let timeout = new Date(date).getTime();

  if (typeof(Storage) !== 'undefined') {
    for (let key in localStorage) {
      let value = localStorage.getItem(key);
      try {
        let data = JSON.parse(value);
        if (data && data.hasOwnProperty('timestamp') && data.timestamp < timeout) {
          localStorage.removeItem(key);
        }
      } catch (e) {}
    }
  }
}
